/**
 * Standard deck registry.
 * Import all standard decks here and export them as a single collection.
 */

import { Deck } from '../shared/types';
import { moviesDeck } from './movies';
import { musicDeck } from './music';
import { sportsDeck } from './sports';

export const standardDecks: Deck[] = [moviesDeck, musicDeck, sportsDeck];

export function getDeckById(id: string): Deck | undefined {
  return standardDecks.find((deck) => deck.id === id);
}

export { moviesDeck, musicDeck, sportsDeck };
